(function(){
    'use strict'

    angular
    .module('app.variables')
    .controller('Variables', Variables);

    Variables.$inject = ['$animationsSrv', 'VariablesService', 'logger', '$location', 'UserInfoService'];

    function Variables($animationsSrv, VariablesService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.variables = [];
        vm.title = 'Variables';

        vm.goToEdit = function(variable){
            
            var path = '/editar-variable/';

            if(variable){
                $location.path(path + variable.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = VariablesService.getAll();

            promise
            .then(function(variables){
                vm.variables = variables;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener las variables.');
                        break;
                }
            });
        };

        vm.delete = function(variable){
            var promise = VariablesService.remove(variable);
            
            promise
            .then(function(response){
                vm.variables = vm.variables.filter(function(g) {
                    return g.id !== variable.id;
                });
                logger.success('Variable eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Variable');
                        break;
                }
                
            });   
        };

    }
})();